export const SERVICE_CODE = 'PAYMENT' + '_METHOD' + '_SERVICE';
